import { Field, reduxForm } from 'redux-form/immutable';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Button from '../../../ui/Button';
import Form from '../../../ui/Form';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.input.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage id={props.label} />
                </Form.Label>
            )}
            <Input {...props.input} disabled={props.disabled} type={props.type}/>
            {props.input.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.input.hint} />
                </Form.Hint>
            )}
            {props.touched && props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

const validate = values => {
    const errors = {};

    const email = values.get('email');
    const password = values.get('password');

    if (email && !email.length) {
        errors.email = 'Required';
    }
    if (password && !password.length) {
        errors.email = 'Required';
    }

    return errors;
};

@injectIntl
export class LoginForm extends Component {
/* eslint-enable */
    static propTypes = {
        intl: intlShape,
        handleSubmit: PropTypes.func,
        submitting: PropTypes.bool,
    }

    render() {
        const { handleSubmit, submitting } = this.props;
        // const { formatHTMLMessage } = this.props.intl;

        return (
            <Form onSubmit={handleSubmit}>
                <Form.Fieldset>
                    <h3>
                        <FormattedMessage id='frontend.form_login.headline' />
                    </h3>

                    <Form.Row>
                        <Field
                            name='email'
                            label='frontend.form_login.label.email'
                            component={renderField}
                            type='email'
                            required
                            props={{disabled: submitting}}
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='password'
                            label='frontend.form_login.label.password'
                            component={renderField}
                            type='password'
                            required
                            props={{disabled: submitting}}
                        />
                        <Form.Hint style={{ textAlign: 'right' }}>
                            <a href='/auth/reset'>
                                <FormattedMessage
                                    id='frontend.form_login.button.reset'
                                />
                            </a>
                        </Form.Hint>
                    </Form.Row>
                    <Form.Row>
                        <Field
                            component='input'
                            id='remember'
                            name='remember'
                            type='checkbox'
                            props={{disabled: submitting}}
                        />
                        {' '}
                        <label htmlFor='remember'>
                            <FormattedMessage
                                id='frontend.form_login.label.remember'
                            />
                        </label>
                    </Form.Row>
                </Form.Fieldset>

                <Button emphasis='primary' type='submit' block disabled={submitting}>
                    <FormattedMessage id='frontend.form_login.button.login' />
                </Button>
            </Form>
        );
    }
}

const FormComponent = reduxForm({
    form: 'account.login',
    validate,
})(LoginForm);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
